import { render, staticRenderFns } from "./NotActive.vue?vue&type=template&id=6c30f3d3&scoped=true"
import script from "./NotActive.vue?vue&type=script&lang=js"
export * from "./NotActive.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6c30f3d3",
  null
  
)

export default component.exports